import React from "react"

import "../../Components/Forms/Form.css"
import "../../Components/Commons/Commons.css"
import "quill/dist/quill.snow.css"

import SidebarMenu from "../../Components/Sidebar/Sidebar"
import Forms from "../../Components/Forms/Forms"
import BtnPrintPdf from "../../Components/Commons/Buttons/BtnPrintPdf"

import { Col, Row } from "react-bootstrap"
// import { getDateToday } from "../../Helpers/Utils/Common"

function Letterhead() {

  return (
    <div className="App">
      <SidebarMenu active={"Reports"} active_sub={"Letterhead"}/>
      <div className="col p-5 pt-4 manager-container overflow leeterHead-wholeContainer" >
        <Row className="justify-content-between align-items-center mb-3">
          <Col xs={10}>
            <div className="col font-big title-2 all-patient">Letterhead</div>
          </Col>
          <Col>
            <BtnPrintPdf
              label={"Print"}
              size={"xl"}
              divId={'letterhead_content'}
              // divId={`prescription_${assessmentId}`}
              fileName={`Letterhead.pdf`}
            />
          </Col>
        </Row>
        <Forms />
      </div>
    </div>
  )
}
export default Letterhead
